/* Krampus back-in-stock signup -> Mailchimp "Krampus Restock Alerts" (restock-only audience). */
(function () {
  if (window.__khNotify) return; window.__khNotify = true;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function jsonp(url) {
    return new Promise(function (resolve, reject) {
      var cb = 'khmc_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
      var s = document.createElement('script');
      var timer = setTimeout(function () { done(); reject(new Error('timeout')); }, 15000);
      function done() { clearTimeout(timer); try { delete window[cb]; } catch (e) { window[cb] = undefined; } if (s.parentNode) s.parentNode.removeChild(s); }
      window[cb] = function (data) { done(); resolve(data || {}); };
      s.onerror = function () { done(); reject(new Error('network')); };
      s.src = url + '&c=' + cb;
      document.head.appendChild(s);
    });
  }
  function clean(msg) { var d = document.createElement('div'); d.innerHTML = String(msg || ''); return (d.textContent || '').replace(/^\d+\s*-\s*/, '').trim(); }
  function setMsg(el, text, kind) { el.textContent = text || ''; el.classList.toggle('is-error', kind === 'error'); el.classList.toggle('is-success', kind === 'success'); }

  function init(root) {
    var toggle = root.querySelector('[data-kh-notify-toggle]');
    var form = root.querySelector('[data-kh-notify-form]');
    var msg = root.querySelector('[data-kh-notify-msg]');
    var input = form.querySelector('input[type=email]');
    var submit = form.querySelector('[type=submit]');
    function open(focus) { form.hidden = false; toggle.setAttribute('aria-expanded', 'true'); if (focus) input.focus(); }
    toggle.addEventListener('click', function () { if (form.hidden) open(true); else { form.hidden = true; toggle.setAttribute('aria-expanded', 'false'); } });
    if (location.hash === '#notify') { open(false); setTimeout(function () { root.scrollIntoView({ block: 'center' }); input.focus({ preventScroll: true }); }, 300); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.busy === 'true') return;
      if (form.querySelector('[name=b_hp]').value) return;
      var email = input.value.trim();
      if (!EMAIL_RE.test(email)) { setMsg(msg, 'Please enter a valid email address.', 'error'); input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
      input.removeAttribute('aria-invalid');
      form.dataset.busy = 'true'; submit.setAttribute('aria-disabled', 'true'); setMsg(msg, 'Adding you to the list…');
      var q = '&EMAIL=' + encodeURIComponent(email) + '&PRODUCT=' + encodeURIComponent(root.dataset.product) + '&b_4e80984e23a6f9182df3e3fe3_df66613ecf=';
      jsonp(root.dataset.endpoint + q).then(function (r) {
        var text = clean(r.msg);
        var ok = r.result === 'success' || /already subscribed/i.test(text);
        if (!ok) {
          if (/too many/i.test(text)) text = 'Too many attempts with this address. Please try again in a few minutes.';
          setMsg(msg, text || 'Sorry, we couldn\'t add you. Please try again.', 'error');
          return;
        }
        var finish = function () { setMsg(msg, root.dataset.success, 'success'); input.value = ''; };
        if (form.querySelector('[name=marketing]').checked && root.dataset.marketingEndpoint) {
          return jsonp(root.dataset.marketingEndpoint + '&EMAIL=' + encodeURIComponent(email)).catch(function () {}).then(finish);
        }
        finish();
      }).catch(function () {
        setMsg(msg, 'We couldn\'t reach our sign-up service. Check your connection and try again.', 'error');
      }).finally(function () { delete form.dataset.busy; submit.removeAttribute('aria-disabled'); });
    });
  }
  function boot() { document.querySelectorAll('[data-kh-notify]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
